import * as React from "react";
import {createElement, useCallback} from "react";
import {MenuItem, TextField} from "@mui/material";
import {TemplateType} from "../../domain/TenantUser";
import {useLocalization} from "../../i18n";

interface TemplateTypeInputProps {
    options: TemplateType[];
    label: string;
    value: TemplateType;
    onChange: (type: TemplateType) => void;
}

export function TemplateTypeInput(props: TemplateTypeInputProps) {
    const {options, label, value, onChange} = props;
    const {e} = useLocalization();

    const handleChange = useCallback((str: string) => {
        onChange(str as TemplateType);
    }, [onChange]);

    return (
        <TextField variant="outlined" select fullWidth label={label} value={value}
                   onChange={(e) => handleChange(e.target.value)}>
            {options.map((type) =>
                <MenuItem key={type} value={type}>{e('tenants.templateTypes', type)}</MenuItem>
            )}
        </TextField>
    );
}
